import styled from "styled-components";

import { Button } from "../components/primitives";
import { Leaderboard } from "./Leaderboard";

// The no-context global board: the shared Leaderboard locked to global scope,
// framed with a "you're in a DM" note and a sticky "choose a chat" CTA.
const Screen = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space(4)};
  padding: ${({ theme }) => theme.space(4)};
  padding-bottom: ${({ theme }) => theme.space(6)};
`;

const Note = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 10px 12px;
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.color.surfaceAlt};
  border: 1px dashed ${({ theme }) => theme.color.borderHi};
  font-size: 12px;
  line-height: 1.35;
  color: ${({ theme }) => theme.color.textDim};

  .icon {
    flex-shrink: 0;
    font-family: ${({ theme }) => theme.font.mono};
    font-size: 13px;
    color: ${({ theme }) => theme.color.accent};
  }

  b {
    color: ${({ theme }) => theme.color.text};
    font-weight: 600;
  }
`;

const Footer = styled.div`
  position: sticky;
  bottom: 0;
  margin-top: ${({ theme }) => theme.space(2)};
  padding: ${({ theme }) => theme.space(3)} 0 ${({ theme }) => theme.space(4)};
  background: linear-gradient(180deg, transparent, ${({ theme }) => theme.color.base} 40%);
`;

const Mono = styled.span`
  font-family: ${({ theme }) => theme.font.mono};
  font-size: 16px;
`;

export function GlobalBoard({ onChooseChat }: { onChooseChat: () => void }) {
  return (
    <Screen>
      <Note>
        <span className="icon">ℹ</span>
        <div>
          opened from DM — no chat selected. these are <b>all-time global</b> ranks.
        </div>
      </Note>

      <Leaderboard initialScope="global" lockChatScope showMapEntry={false} />

      <Footer>
        <Button $variant="primary" $full onClick={onChooseChat}>
          <Mono>⌕</Mono> choose a chat
        </Button>
      </Footer>
    </Screen>
  );
}
